import { motion } from "framer-motion";

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="bg-slate-900 text-slate-50 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-3">
            <p className="font-mono uppercase tracking-[0.24em] text-xs text-slate-400">
              — Philosophy
            </p>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9 }}
              className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-slate-50"
            >
              Every module ends with something that <em className="text-slate-300">runs in production.</em>{" "}
              Not a report. Not a notebook. A live system with metrics,
              guardrails and a rollback plan.
            </motion.h2>

            <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-slate-800 pt-14">
              {[
                {
                  k: "01",
                  t: "Project-driven",
                  d: "Each of the six phases is anchored to a real industry deployment. Concepts follow the code — not the other way around.",
                },
                {
                  k: "02",
                  t: "Enterprise stacks",
                  d: "Anthropic Claude, GPT, Gemini, Vertex AI, Azure AI Foundry, LangGraph, CrewAI, MLflow, Docker, K8s — used, not just discussed.",
                },
                {
                  k: "03",
                  t: "Portfolio-first",
                  d: "Ship a live portfolio of deployed AI systems across BPO, BFSI, Healthcare, Retail and SaaS by the time you graduate.",
                },
              ].map((b) => (
                <div key={b.k} data-testid={`philosophy-pillar-${b.k}`}>
                  <p className="font-mono text-xs text-slate-500 tracking-[0.24em] uppercase mb-4">
                    {b.k}
                  </p>
                  <h3 className="font-serif text-2xl text-slate-50 mb-3">{b.t}</h3>
                  <p className="text-slate-400 font-sans leading-relaxed text-sm">{b.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
